import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  container: {
    my: '120px',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',

    [theme.breakpoints.between('md', 'lg')]: {
      height: '700px',
    },

    [theme.breakpoints.down('md')]: {
      my: '80px',
    },
  },

  card: {
    backgroundImage: 'linear-gradient(to bottom right, #C795DD, #412167)',
    height: '456px',
    width: '80%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 'fit-content',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },

  textBox: {
    width: '55%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
  },

  image: {
    position: 'relative',
    width: '576px',
    height: '576px',

    [theme.breakpoints.between('md', 'lg')]: {
      width: '400px',
      height: '400px',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      ml: '0px',
      pt: '0px',
      width: '350px',
      height: '350px',
    },

    [theme.breakpoints.down('sm')]: {
      mb: '0px',
      mt: '0px',
      width: '335px',
      height: '335px',
    },
  },

  textAndButtonBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      mb: '90px',
    },
  },

  text: {
    color: 'white',
    textAlign: 'left',
    width: '70%',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      mt: '24px',
      textAlign: 'center',
    },
  },

  button: {
    mt: '20px',
    backgroundColor: 'white',

    [theme.breakpoints.down('md')]: {
      mt: '40px',
    },
  },
});
